export default {
  brand: "USFansLink",
  nav: {
    spreadsheets: "Spreadsheets",
    products: "Products",
    sellers: "Sellers",
    reviews: "Reviews",
    shipping: "Shipping",
    coupons: "Coupons",
    guides: "Guides",
    safety: "Safety",
    buyNow: "Buy It Now",
    home: "Home",
    shoppingGuide: "Shopping Guide",
    categories: "Categories",
    chooseLanguage: "Language",
  },
  hero: {
    badge: "Independent Resource • Updated Guides • Multilingual Support",
    title: "USFans Spreadsheet – Find Products, Sellers & Shopping Guides",
    subtitle:
      "Explore the USFans Spreadsheet to discover useful product lists, seller resources, shopping guides, shipping information, QC tips and the latest USFans resources — organized in one easy-to-use hub.",
    ctaPrimary: "USFans Spreadsheet",
    ctaSecondary: "Buy It Now",
    hint: "Opens the official USFans store in a new tab",
  },
  categories: {
    title: "Browse Products by Category",
    subtitle:
      "Jump straight to the category you need. Every link opens the USFans store so you can keep shopping without the hassle.",
    dropdownLabel: "Choose a category",
    dropdownPlaceholder: "Select a category…",
    openLabel: "View category",
    shoes: "Shoes",
    hoodies: "Hoodies & Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants & Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear & Underpants",
    jerseys: "Jerseys",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  resources: {
    title: "Everything You Need to Research USFans Products",
    subtitle:
      "Searching for products, sellers or useful USFans information can be time-consuming. USFansLink organizes important resources into clear spreadsheets, guides, comparisons and tutorials so you can research products more efficiently and make better-informed decisions.",
    cards: {
      spreadsheet: { title: "USFans Spreadsheet", desc: "Organized product and seller information in one clear, filterable view." },
      productLists: { title: "Product Lists", desc: "Curated lists that help you compare items across categories quickly." },
      sellerGuides: { title: "Seller Guides", desc: "Practical tips for researching sellers and reading their track record." },
      shippingGuides: { title: "Shipping Guides", desc: "Clear explanations of shipping options, costs and delivery timing." },
      qcResources: { title: "QC Resources", desc: "Checklists and photo tips to review quality before you buy." },
      safetyGuides: { title: "Safety Guides", desc: "Account security, suspicious links and payment awareness in one place." },
    },
  },
  spreadsheet: {
    title: "USFans Spreadsheet",
    text: "Start with the USFans Spreadsheet to explore organized product and seller information. Use filters, categories and supporting guides to narrow down what you are looking for before making a decision.",
    cta: "Open Spreadsheet Guide",
  },
  popular: {
    title: "Popular USFans Resources",
    subtitle: "Quick access to the topics shoppers search for most.",
    comingSoon: "Guide coming soon",
    cards: {
      review: { title: "USFans Review", desc: "An independent look at features, workflow and overall experience." },
      shippingCost: { title: "USFans Shipping Cost", desc: "How shipping options and costs can vary by destination." },
      coupon: { title: "USFans Coupon", desc: "Where to look for current offers and how to apply them." },
      discountCode: { title: "USFans Discount Code", desc: "Tips for finding available deals before checkout." },
      warehouse: { title: "USFans Warehouse", desc: "How storage and warehouse processes affect delivery." },
      legit: { title: "Is USFans Legit?", desc: "A balanced guide to trust and safety considerations." },
    },
  },
  confidence: {
    title: "Research Products With More Confidence",
    text: "Use product information, seller research, QC resources and shipping guides together instead of relying on a single source. Our goal is to make the research process easier to understand.",
  },
  shipping: {
    title: "USFans Shipping, Warehouse & Delivery Guides",
    text: "Learn how shipping options, warehouse processes and delivery considerations can affect your shopping experience.",
    cta: "Explore Shipping Guides",
  },
  review: {
    title: "USFans Review & Experience Guide",
    text: "Looking for a USFans review? Explore our independent guides covering platform features, shopping workflow, shipping, warehouse information, safety considerations and common questions.",
    cta: "Read USFans Review",
  },
  safety: {
    title: "USFans Safety Center",
    text: "Before using any shopping platform or seller resource, understand the potential risks. Our Safety Center covers account security, seller research, QC checks, payment awareness, shipping considerations and suspicious links.",
    cta: "Visit Safety Center",
  },
  guides: {
    title: "Latest USFans Spreadsheet Guides",
    subtitle: "Fresh, original guides to help you research smarter.",
    readMore: "Read Guide",
    article: {
      title: "What Is USFans Spreadsheet? A Complete Guide",
      excerpt:
        "Learn what the USFans Spreadsheet is, what it contains, how to use it to find products and sellers, and what to know about shipping, QC and safety before you shop.",
      tag: "Beginner Guide",
    },
    moreSoon: "More guides are on the way — shipping, coupons, warehouse and review deep-dives.",
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Quick answers to the questions people ask most about the USFans Spreadsheet.",
    questions: {
      q1: "What is a USFans Spreadsheet?",
      a1: "It is an organized resource that brings together product lists, seller information and categories in a single view, so you can compare options without jumping between many pages.",
      q2: "How do I use a USFans Spreadsheet?",
      a2: "Pick a category, then filter or sort the columns you care about, such as price or shipping. Once you narrow down your options, follow the product links to continue on the main store.",
      q3: "Is USFans legit?",
      a3: "USFans is a shopping platform used by many buyers. As with any store, research sellers, review QC photos and stay cautious with unusual payment requests before you buy.",
      q4: "How much does USFans shipping cost?",
      a4: "Shipping costs vary by seller, destination and shipping method. Always confirm the final cost in the shipping column or at checkout before placing an order.",
      q5: "Does USFans have coupons?",
      a5: "Offers and discount codes come and go. Check the latest coupon and discount code resources before checkout, since a code may only work for certain categories or minimum orders.",
      q6: "Where is the USFans warehouse?",
      a6: "Warehouse locations and processes can vary. Review the warehouse notes for the seller you are buying from to understand storage and delivery timing.",
      q7: "How can I research USFans sellers?",
      a7: "Look at the seller's track record, read reviews, check QC photos when available, and verify shipping and payment details before committing to a purchase.",
    },
  },
  finalCta: {
    title: "Start Your USFans Research",
    text: "Explore the USFans Spreadsheet, compare useful resources and continue your product research with our latest guides.",
    cta: "Explore USFans Spreadsheet",
  },
  notFound: {
    title: "This page has not been generated",
    subtitle: "Tell us more about this page, and we can generate it for you.",
    backHome: "Back to Homepage",
  },
  footer: {
    about: "About",
    contact: "Contact",
    privacy: "Privacy Policy",
    terms: "Terms",
    editorial: "Editorial Policy",
    updates: "Updates",
    disclaimer:
      "USFansLink is an independent informational resource and is not affiliated with or endorsed by USFans unless explicitly stated.",
    rights: "All rights reserved.",
  },
};